import { CUSTOMER_FEEDBACK } from 'redux/modules/customer-feedback/actions/types';

import customerFeedback from './customerFeedback';

export default {
  [CUSTOMER_FEEDBACK]: customerFeedback,
};
